import React, { useState } from 'react';
import { 
  Trophy, 
  Calendar, 
  Users, 
  Loader2, 
  CheckCircle2, 
  AlertCircle,
  ChevronDown,
  ChevronRight,
  Send,
  FileText,
  Sparkles,
  BookOpen,
  User,
  GraduationCap,
  X,
  School,
  Check,
  Trash2,
  RefreshCw,
  Edit3,
  MessageSquare,
  Plus,
  Save,
  ArrowLeft,
  Clock,
  AlertTriangle,
  Bot
} from 'lucide-react';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

// Demo restriction modal component
const DemoRestrictionModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-gray-900 border border-amber-500/30 rounded-2xl p-6 max-w-md w-full shadow-2xl">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-1 rounded-lg hover:bg-gray-800 text-gray-400 hover:text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-amber-500/20 flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-amber-400" />
          </div>
        </div>
        
        {/* Content */}
        <h3 className="text-xl font-bold text-white text-center mb-2">
          Modo Demo
        </h3>
        <p className="text-gray-400 text-center mb-4">
          Esta es una versión de demostración. Los retos para <span className="text-amber-400 font-medium">1º de Bachiller</span> no están disponibles.
        </p>
        
        {/* Suggestion */}
        <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-xl p-4 mb-6">
          <p className="text-emerald-300 text-sm text-center">
            💡 <span className="font-medium">Sugerencia:</span> Asigna retos a <span className="font-bold">2º de Bachiller</span> para ver todas las funcionalidades del sistema.
          </p>
        </div>
        
        {/* Button */}
        <button
          onClick={onClose}
          className="w-full py-3 bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-xl transition-colors"
        >
          Entendido
        </button>
      </div>
    </div>
  );
};

// Academic data - same structure as MisClasesView
const ACADEMIC_DATA = {
  courses: [
    {
      id: '1-bach',
      name: '1º de Bachiller',
      subjects: [
        { 
          id: 'lengua-1', 
          name: 'Lengua Castellana y Literatura',
          groups: [
            {
              id: '1a-lengua',
              name: 'Grupo A',
              students: [
                { id: 's1a1', name: 'Carlos Mendoza' },
                { id: 's1a2', name: 'María García López' },
                { id: 's1a3', name: 'James Thompson' },
                { id: 's1a4', name: 'Sophie Dubois' },
                { id: 's1a5', name: 'Alessandro Rossi' },
                { id: 's1a6', name: 'Yuki Tanaka' },
                { id: 's1a7', name: 'Hans Müller' },
                { id: 's1a8', name: 'Elena Sánchez' },
                { id: 's1a9', name: 'Pablo Fernández' },
                { id: 's1a10', name: 'Camille Lefebvre' },
                { id: 's1a11', name: 'Antonio Ruiz' },
                { id: 's1a12', name: 'Emma Williams' }
              ]
            },
            {
              id: '1b-lengua',
              name: 'Grupo B',
              students: [
                { id: 's1b1', name: 'Lucía Martínez' },
                { id: 's1b2', name: 'David Chen' },
                { id: 's1b3', name: 'Amélie Bernard' },
                { id: 's1b4', name: 'Marco Bianchi' },
                { id: 's1b5', name: 'Kenji Yamamoto' },
                { id: 's1b6', name: 'Friedrich Weber' },
                { id: 's1b7', name: 'Isabel Torres' },
                { id: 's1b8', name: 'Robert Johnson' },
                { id: 's1b9', name: 'Ana Moreno' },
                { id: 's1b10', name: 'Pierre Martin' },
                { id: 's1b11', name: 'Laura Díaz' },
                { id: 's1b12', name: 'Takeshi Sato' },
                { id: 's1b13', name: 'Carmen Vega' }
              ]
            }
          ]
        }
      ]
    },
    {
      id: '2-bach',
      name: '2º de Bachiller',
      subjects: [
        { 
          id: 'filosofia', 
          name: 'Filosofía',
          groups: [
            {
              id: '2a-filo',
              name: 'Grupo A',
              students: [
                { id: 's2a1', name: 'Carlos Mendoza' },
                { id: 's2a2', name: 'Andrea Gómez' },
                { id: 's2a3', name: 'William Brown' },
                { id: 's2a4', name: 'Charlotte Moreau' },
                { id: 's2a5', name: 'Luca Ferrari' },
                { id: 's2a6', name: 'Sakura Nakamura' },
                { id: 's2a7', name: 'Klaus Schmidt' },
                { id: 's2a8', name: 'Sofía Herrera' },
                { id: 's2a9', name: 'Diego Navarro' },
                { id: 's2a10', name: 'Émile Rousseau' },
                { id: 's2a11', name: 'Victoria Lozano' }
              ]
            },
            {
              id: '2b-filo',
              name: 'Grupo B',
              students: [
                { id: 's2b1', name: 'Raúl Jiménez' },
                { id: 's2b2', name: 'Olivia Davis' },
                { id: 's2b3', name: 'Margaux Petit' },
                { id: 's2b4', name: 'Giovanni Romano' },
                { id: 's2b5', name: 'Haruki Watanabe' },
                { id: 's2b6', name: 'Maximilian Fischer' },
                { id: 's2b7', name: 'Paula Serrano' },
                { id: 's2b8', name: 'Michael Anderson' },
                { id: 's2b9', name: 'Cristina Molina' },
                { id: 's2b10', name: 'Louis Dupont' },
                { id: 's2b11', name: 'Marta Ortega' },
                { id: 's2b12', name: 'Benjamin Taylor' },
                { id: 's2b13', name: 'Rosa Delgado' },
                { id: 's2b14', name: 'Hiroshi Kimura' }
              ]
            }
          ]
        },
        { 
          id: 'historia-arte', 
          name: 'Historia del Arte',
          groups: [
            {
              id: '2a-arte',
              name: 'Grupo A',
              students: [
                { id: 's2a1', name: 'Carlos Mendoza' },
                { id: 's2a2', name: 'Andrea Gómez' },
                { id: 's2a3', name: 'William Brown' },
                { id: 's2a4', name: 'Charlotte Moreau' },
                { id: 's2a5', name: 'Luca Ferrari' },
                { id: 's2a6', name: 'Sakura Nakamura' },
                { id: 's2a7', name: 'Klaus Schmidt' },
                { id: 's2a8', name: 'Sofía Herrera' },
                { id: 's2a9', name: 'Diego Navarro' },
                { id: 's2a10', name: 'Émile Rousseau' },
                { id: 's2a11', name: 'Victoria Lozano' }
              ]
            },
            {
              id: '2b-arte',
              name: 'Grupo B',
              students: [
                { id: 's2b1', name: 'Raúl Jiménez' },
                { id: 's2b2', name: 'Olivia Davis' },
                { id: 's2b3', name: 'Margaux Petit' },
                { id: 's2b4', name: 'Giovanni Romano' },
                { id: 's2b5', name: 'Haruki Watanabe' },
                { id: 's2b6', name: 'Maximilian Fischer' },
                { id: 's2b7', name: 'Paula Serrano' },
                { id: 's2b8', name: 'Michael Anderson' },
                { id: 's2b9', name: 'Cristina Molina' },
                { id: 's2b10', name: 'Louis Dupont' },
                { id: 's2b11', name: 'Marta Ortega' },
                { id: 's2b12', name: 'Benjamin Taylor' },
                { id: 's2b13', name: 'Rosa Delgado' },
                { id: 's2b14', name: 'Hiroshi Kimura' }
              ]
            }
          ]
        },
        { 
          id: 'cultura-audiovisual', 
          name: 'Cultura Audiovisual',
          groups: [
            {
              id: '2a-cultura',
              name: 'Grupo A',
              students: [
                { id: 's2a1', name: 'Carlos Mendoza' },
                { id: 's2a2', name: 'Andrea Gómez' },
                { id: 's2a3', name: 'William Brown' },
                { id: 's2a4', name: 'Charlotte Moreau' },
                { id: 's2a5', name: 'Luca Ferrari' },
                { id: 's2a6', name: 'Sakura Nakamura' },
                { id: 's2a7', name: 'Klaus Schmidt' },
                { id: 's2a8', name: 'Sofía Herrera' },
                { id: 's2a9', name: 'Diego Navarro' },
                { id: 's2a10', name: 'Émile Rousseau' },
                { id: 's2a11', name: 'Victoria Lozano' }
              ]
            },
            {
              id: '2b-cultura',
              name: 'Grupo B',
              students: [
                { id: 's2b1', name: 'Raúl Jiménez' },
                { id: 's2b2', name: 'Olivia Davis' },
                { id: 's2b3', name: 'Margaux Petit' },
                { id: 's2b4', name: 'Giovanni Romano' },
                { id: 's2b5', name: 'Haruki Watanabe' },
                { id: 's2b6', name: 'Maximilian Fischer' },
                { id: 's2b7', name: 'Paula Serrano' },
                { id: 's2b8', name: 'Michael Anderson' },
                { id: 's2b9', name: 'Cristina Molina' },
                { id: 's2b10', name: 'Louis Dupont' },
                { id: 's2b11', name: 'Marta Ortega' },
                { id: 's2b12', name: 'Benjamin Taylor' },
                { id: 's2b13', name: 'Rosa Delgado' },
                { id: 's2b14', name: 'Hiroshi Kimura' }
              ]
            }
          ]
        }
      ]
    }
  ]
};

// Helper function to count students based on recipient selection
const countStudentsForRecipient = (recipient) => {
  if (!recipient) return 0;
  
  if (recipient.type === 'student') {
    return 1;
  }
  
  if (recipient.type === 'group') {
    // Find the group and count its students
    for (const course of ACADEMIC_DATA.courses) {
      for (const subject of course.subjects) {
        const group = subject.groups.find(g => g.id === recipient.groupId);
        if (group) return group.students.length;
      }
    }
    return 0;
  }
  
  if (recipient.type === 'subject') {
    // Count all students in all groups of this subject
    for (const course of ACADEMIC_DATA.courses) {
      const subject = course.subjects.find(s => s.id === recipient.subjectId);
      if (subject) {
        return subject.groups.reduce((total, group) => total + group.students.length, 0);
      }
    }
    return 0;
  }
  
  if (recipient.type === 'course') {
    // Count all students in all subjects of this course
    const course = ACADEMIC_DATA.courses.find(c => c.id === recipient.courseId);
    if (course) {
      let total = 0;
      course.subjects.forEach(subject => {
        subject.groups.forEach(group => {
          total += group.students.length;
        });
      });
      return total;
    }
    return 0;
  }
  
  return 0;
};

// Format date to Spanish format
const formatDateSpanish = (dateString) => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  return `${parseInt(day)} de ${months[parseInt(month) - 1]} de ${year}`;
};

// ============================================
// RECIPIENT TREE SELECTOR COMPONENT
// ============================================
const RecipientTreeSelector = ({ selectedRecipient, onSelect, onBlockedSelection }) => {
  const [expandedCourses, setExpandedCourses] = useState({});
  const [expandedSubjects, setExpandedSubjects] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({});

  const toggleCourse = (courseId, e) => {
    e.stopPropagation();
    setExpandedCourses(prev => ({ ...prev, [courseId]: !prev[courseId] }));
  };

  const toggleSubject = (subjectId, e) => {
    e.stopPropagation();
    setExpandedSubjects(prev => ({ ...prev, [subjectId]: !prev[subjectId] }));
  };

  const toggleGroup = (groupId, e) => {
    e.stopPropagation();
    setExpandedGroups(prev => ({ ...prev, [groupId]: !prev[groupId] }));
  };

  const isSelected = (type, id) => {
    return selectedRecipient?.type === type && selectedRecipient?.id === id;
  };

  const getCourseStats = (course) => {
    let totalGroups = 0;
    course.subjects.forEach(subject => {
      totalGroups += subject.groups.length;
    });
    return { totalGroups, totalSubjects: course.subjects.length };
  };

  // Check if a course is 1º de Bachiller (demo blocked)
  const isFirstYear = (courseId) => courseId === '1-bach';

  const handleSelectCourse = (course) => {
    // Block 1º de Bachiller selections
    if (isFirstYear(course.id)) {
      onBlockedSelection();
      return;
    }
    onSelect({
      id: `course-${course.id}`,
      type: 'course',
      label: course.name,
      courseId: course.id,
      courseName: course.name,
      subjectId: null
    });
  };

  const handleSelectSubject = (course, subject) => {
    // Block 1º de Bachiller selections
    if (isFirstYear(course.id)) {
      onBlockedSelection();
      return;
    }
    onSelect({
      id: `subject-${subject.id}`,
      type: 'subject',
      label: `${course.name}, ${subject.name}`,
      courseId: course.id,
      courseName: course.name,
      subjectId: subject.id,
      subjectName: subject.name
    });
  };

  const handleSelectGroup = (course, subject, group) => {
    // Block 1º de Bachiller selections
    if (isFirstYear(course.id)) {
      onBlockedSelection();
      return;
    }
    onSelect({
      id: `group-${group.id}`,
      type: 'group',
      label: `${course.name}, ${subject.name}, ${group.name}`,
      courseId: course.id,
      courseName: course.name,
      subjectId: subject.id,
      subjectName: subject.name,
      groupId: group.id,
      groupName: group.name
    });
  };

  const handleSelectStudent = (course, subject, group, student) => {
    // Block 1º de Bachiller selections
    if (isFirstYear(course.id)) {
      onBlockedSelection();
      return;
    }
    onSelect({
      id: `student-${student.id}-${group.id}`,
      type: 'student',
      label: `${course.name}, ${subject.name}, ${group.name} — ${student.name}`,
      courseId: course.id,
      courseName: course.name,
      subjectId: subject.id,
      subjectName: subject.name,
      groupId: group.id,
      groupName: group.name,
      studentId: student.id,
      studentName: student.name
    });
  };

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700/50 overflow-hidden">
      <div className="px-4 py-3 bg-gradient-to-r from-indigo-600/20 to-purple-600/20 border-b border-gray-700/50">
        <div className="flex items-center gap-2">
          <School className="w-4 h-4 text-indigo-400" />
          <h2 className="text-sm font-semibold text-white">Envíalo a</h2>
        </div>
        {selectedRecipient && (
          <p className="text-xs text-amber-400 mt-1 flex items-center gap-1">
            <Check className="w-3 h-3" />
            {selectedRecipient.label}
          </p>
        )}
      </div>
      
      <div className="p-3 max-h-[300px] overflow-y-auto">
        {ACADEMIC_DATA.courses.map(course => {
          const stats = getCourseStats(course);
          const isCourseSelected = isSelected('course', `course-${course.id}`);
          
          return (
            <div key={course.id} className="mb-2 last:mb-0">
              <div className="flex items-center gap-1">
                <button
                  onClick={(e) => toggleCourse(course.id, e)}
                  className="p-1 hover:bg-gray-700/50 rounded transition-colors"
                >
                  {expandedCourses[course.id] ? (
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                  ) : (
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  )}
                </button>
                <button
                  onClick={() => handleSelectCourse(course)}
                  className={`flex-1 flex items-center gap-2 p-2 rounded-lg transition-colors ${
                    isCourseSelected 
                      ? 'bg-amber-500/20 border border-amber-500/50' 
                      : 'bg-gray-700/30 hover:bg-gray-700/50'
                  }`}
                >
                  <GraduationCap className={`w-4 h-4 ${isCourseSelected ? 'text-amber-400' : 'text-indigo-400'}`} />
                  <span className={`text-sm font-medium ${isCourseSelected ? 'text-amber-300' : 'text-white'}`}>
                    {course.name}
                  </span>
                  <span className="ml-auto text-xs text-gray-500">
                    {stats.totalSubjects} asig. • {stats.totalGroups} grupos
                  </span>
                  {isCourseSelected && <Check className="w-4 h-4 text-amber-400" />}
                </button>
              </div>
              
              {expandedCourses[course.id] && (
                <div className="mt-2 ml-6 space-y-1.5">
                  {course.subjects.map(subject => {
                    const isSubjectSelected = isSelected('subject', `subject-${subject.id}`);
                    
                    return (
                      <div key={subject.id}>
                        <div className="flex items-center gap-1">
                          <button
                            onClick={(e) => toggleSubject(subject.id, e)}
                            className="p-1 hover:bg-gray-700/50 rounded transition-colors"
                          >
                            {expandedSubjects[subject.id] ? (
                              <ChevronDown className="w-3.5 h-3.5 text-amber-400" />
                            ) : (
                              <ChevronRight className="w-3.5 h-3.5 text-amber-400" />
                            )}
                          </button>
                          <button
                            onClick={() => handleSelectSubject(course, subject)}
                            className={`flex-1 flex items-center gap-2 p-2 rounded-lg transition-colors border ${
                              isSubjectSelected 
                                ? 'bg-amber-500/30 border-amber-500/50' 
                                : 'bg-amber-500/10 hover:bg-amber-500/20 border-amber-500/20'
                            }`}
                          >
                            <BookOpen className="w-3.5 h-3.5 text-amber-400" />
                            <span className={`text-xs font-medium ${isSubjectSelected ? 'text-amber-200' : 'text-amber-300'}`}>
                              {subject.name}
                            </span>
                            <span className="ml-auto text-xs text-gray-500">
                              {subject.groups.length} grupos
                            </span>
                            {isSubjectSelected && <Check className="w-3.5 h-3.5 text-amber-400" />}
                          </button>
                        </div>
                        
                        {expandedSubjects[subject.id] && (
                          <div className="mt-1.5 ml-5 space-y-1">
                            {subject.groups.map(group => {
                              const isGroupSelected = isSelected('group', `group-${group.id}`);
                              
                              return (
                                <div key={group.id}>
                                  <div className="flex items-center gap-1">
                                    <button
                                      onClick={(e) => toggleGroup(group.id, e)}
                                      className="p-1 hover:bg-gray-700/50 rounded transition-colors"
                                    >
                                      {expandedGroups[group.id] ? (
                                        <ChevronDown className="w-3 h-3 text-gray-500" />
                                      ) : (
                                        <ChevronRight className="w-3 h-3 text-gray-500" />
                                      )}
                                    </button>
                                    <button
                                      onClick={() => handleSelectGroup(course, subject, group)}
                                      className={`flex-1 flex items-center gap-2 p-2 rounded-lg transition-colors ${
                                        isGroupSelected 
                                          ? 'bg-emerald-500/30 border border-emerald-500/50' 
                                          : 'bg-gray-800/50 hover:bg-gray-700/30'
                                      }`}
                                    >
                                      <Users className={`w-3 h-3 ${isGroupSelected ? 'text-emerald-300' : 'text-emerald-400'}`} />
                                      <span className={`text-xs font-medium ${isGroupSelected ? 'text-emerald-200' : 'text-gray-300'}`}>
                                        {group.name}
                                      </span>
                                      <span className="ml-auto text-xs text-gray-500">
                                        {group.students.length} alumnos
                                      </span>
                                      {isGroupSelected && <Check className="w-3 h-3 text-emerald-400" />}
                                    </button>
                                  </div>
                                  
                                  {expandedGroups[group.id] && (
                                    <div className="mt-1 ml-5 p-2 bg-gray-900/30 rounded-lg">
                                      <div className="grid grid-cols-2 gap-1">
                                        {group.students.map(student => {
                                          const studentId = `student-${student.id}-${group.id}`;
                                          const isStudentSelected = isSelected('student', studentId);
                                          
                                          return (
                                            <button
                                              key={student.id}
                                              onClick={() => handleSelectStudent(course, subject, group, student)}
                                              className={`flex items-center gap-1.5 px-2 py-1 rounded text-xs transition-colors text-left ${
                                                isStudentSelected
                                                  ? 'bg-blue-500/30 text-blue-200 border border-blue-500/50'
                                                  : 'text-gray-400 hover:bg-gray-700/30 hover:text-gray-300'
                                              }`}
                                            >
                                              <User className="w-3 h-3 flex-shrink-0" />
                                              <span className="truncate">{student.name}</span>
                                              {isStudentSelected && <Check className="w-3 h-3 flex-shrink-0 text-blue-400" />}
                                            </button>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ============================================
// QUESTION CARD COMPONENT
// ============================================
const QuestionCard = ({ 
  question, 
  index, 
  onDelete, 
  onRedo, 
  onConvertToOpen, 
  onEdit,
  isRedoing 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedQuestion, setEditedQuestion] = useState(question.question);
  const [editedOptions, setEditedOptions] = useState(question.options || ['', '', '', '']);
  const [editedCorrectAnswer, setEditedCorrectAnswer] = useState(question.correct_answer || 0);

  const isOpenQuestion = question.type === 'open';

  const handleSaveEdit = () => {
    if (isOpenQuestion) {
      onEdit(index, {
        ...question,
        question: editedQuestion
      });
    } else {
      onEdit(index, {
        ...question,
        question: editedQuestion,
        options: editedOptions,
        correct_answer: editedCorrectAnswer
      });
    }
    setIsEditing(false);
  };

  const handleCancelEdit = () => {
    setEditedQuestion(question.question);
    setEditedOptions(question.options || ['', '', '', '']);
    setEditedCorrectAnswer(question.correct_answer || 0);
    setIsEditing(false);
  };

  const handleOptionChange = (optionIndex, value) => {
    const newOptions = [...editedOptions];
    newOptions[optionIndex] = value;
    setEditedOptions(newOptions);
  };

  return (
    <div className="bg-gray-800/50 rounded-lg border border-gray-700/50 overflow-hidden">
      {/* Question Header */}
      <div className="flex items-center justify-between px-4 py-2 bg-gray-700/30 border-b border-gray-700/50">
        <div className="flex items-center gap-2">
          <span className="w-6 h-6 rounded-full bg-amber-500/20 text-amber-400 flex items-center justify-center text-xs font-bold">
            {index + 1}
          </span>
          <span className={`text-xs px-2 py-0.5 rounded-full ${
            isOpenQuestion 
              ? 'bg-purple-500/20 text-purple-300' 
              : 'bg-blue-500/20 text-blue-300'
          }`}>
            {isOpenQuestion ? 'Respuesta abierta' : 'Opción múltiple'}
          </span>
        </div>
        
        {/* Action Buttons */}
        <div className="flex items-center gap-1">
          {!isOpenQuestion && (
            <button
              onClick={() => onConvertToOpen(index)}
              className="p-1.5 text-purple-400 hover:bg-purple-500/20 rounded-lg transition-colors"
              title="Convertir a pregunta abierta"
            >
              <MessageSquare className="w-4 h-4" />
            </button>
          )}
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="p-1.5 text-blue-400 hover:bg-blue-500/20 rounded-lg transition-colors"
            title="Editar pregunta"
          >
            <Edit3 className="w-4 h-4" />
          </button>
          <button
            onClick={() => onRedo(index)}
            disabled={isRedoing}
            className="p-1.5 text-amber-400 hover:bg-amber-500/20 rounded-lg transition-colors disabled:opacity-50"
            title="Rehacer pregunta (generar nueva)"
          >
            {isRedoing ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <RefreshCw className="w-4 h-4" />
            )}
          </button>
          <button
            onClick={() => onDelete(index)}
            className="p-1.5 text-red-400 hover:bg-red-500/20 rounded-lg transition-colors"
            title="Eliminar pregunta"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Question Content */}
      <div className="p-4">
        {isEditing ? (
          <div className="space-y-3">
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Enunciado de la pregunta:</label>
              <textarea
                value={editedQuestion}
                onChange={(e) => setEditedQuestion(e.target.value)}
                className="w-full px-3 py-2 bg-gray-900/50 border border-gray-600 rounded-lg text-sm text-white focus:outline-none focus:border-amber-500/50 resize-none"
                rows={2}
              />
            </div>
            
            {!isOpenQuestion && (
              <div className="space-y-2">
                <label className="text-xs text-gray-400">Opciones de respuesta:</label>
                {editedOptions.map((opt, optIdx) => (
                  <div key={optIdx} className="flex items-center gap-2">
                    <button
                      onClick={() => setEditedCorrectAnswer(optIdx)}
                      className={`w-6 h-6 rounded-full border-2 flex items-center justify-center text-xs font-medium transition-colors ${
                        editedCorrectAnswer === optIdx
                          ? 'border-emerald-500 bg-emerald-500/20 text-emerald-300'
                          : 'border-gray-600 text-gray-400 hover:border-gray-500'
                      }`}
                    >
                      {String.fromCharCode(65 + optIdx)}
                    </button>
                    <input
                      type="text"
                      value={opt}
                      onChange={(e) => handleOptionChange(optIdx, e.target.value)}
                      className="flex-1 px-3 py-1.5 bg-gray-900/50 border border-gray-600 rounded-lg text-sm text-white focus:outline-none focus:border-amber-500/50"
                      placeholder={`Opción ${String.fromCharCode(65 + optIdx)}`}
                    />
                    {editedCorrectAnswer === optIdx && (
                      <span className="text-xs text-emerald-400">✓ Correcta</span>
                    )}
                  </div>
                ))}
                <p className="text-xs text-gray-500">Haz clic en la letra para marcar la respuesta correcta</p>
              </div>
            )}

            {isOpenQuestion && (
              <p className="text-xs text-gray-500 italic">
                El alumno responderá con un texto de máximo 150 palabras
              </p>
            )}
            
            <div className="flex justify-end gap-2 pt-2">
              <button
                onClick={handleCancelEdit}
                className="px-3 py-1.5 text-xs text-gray-400 hover:text-white transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={handleSaveEdit}
                className="flex items-center gap-1 px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-xs font-medium rounded-lg transition-colors"
              >
                <Save className="w-3 h-3" />
                Guardar cambios
              </button>
            </div>
          </div>
        ) : (
          <div>
            <p className="text-sm text-white font-medium leading-relaxed mb-3">{question.question}</p>
            
            {isOpenQuestion ? (
              <div className="p-3 bg-purple-500/10 border border-purple-500/20 rounded-lg">
                <p className="text-xs text-purple-300 italic">
                  Respuesta abierta (máximo 150 palabras)
                </p>
              </div>
            ) : (
              <div className="space-y-2">
                {question.options?.map((opt, optIdx) => (
                  <div 
                    key={optIdx}
                    className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm ${
                      optIdx === question.correct_answer 
                        ? 'bg-emerald-500/20 border border-emerald-500/30 text-emerald-300' 
                        : 'bg-gray-700/30 text-gray-400'
                    }`}
                  >
                    <span className="w-5 h-5 rounded-full border flex items-center justify-center text-xs font-medium">
                      {String.fromCharCode(65 + optIdx)}
                    </span>
                    <span>{opt}</span>
                    {optIdx === question.correct_answer && (
                      <CheckCircle2 className="w-4 h-4 ml-auto text-emerald-400" />
                    )}
                  </div>
                ))}
              </div>
            )}
            
            {question.source && (
              <p className="mt-2 text-xs text-gray-500 italic">
                Fuente: {question.source}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// ============================================
// SUCCESS MODAL
// ============================================
const SuccessModal = ({ isOpen, onClose, recipientLabel, studentCount }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4"
      onClick={onClose}
    >
      <div 
        className="bg-gray-900 rounded-xl border border-gray-700 max-w-sm w-full overflow-hidden shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="p-6 text-center">
          <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="w-8 h-8 text-emerald-400" />
          </div>
          <h3 className="text-lg font-semibold text-white mb-2">¡Reto enviado!</h3>
          <p className="text-sm text-gray-400 mb-4">
            El reto ha sido enviado correctamente a {studentCount} alumno{studentCount !== 1 ? 's' : ''}:
          </p>
          <p className="text-sm text-amber-300 font-medium bg-amber-500/10 px-3 py-2 rounded-lg">
            {recipientLabel}
          </p>
        </div>
        <div className="p-4 border-t border-gray-700 bg-gray-800/30">
          <button
            onClick={onClose}
            className="w-full py-2 bg-gray-700 hover:bg-gray-600 text-white text-sm font-medium rounded-lg transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

// ============================================
// MAIN COMPONENT
// ============================================
const CrearRetosView = () => {
  const [topic, setTopic] = useState('');
  const [deadline, setDeadline] = useState('');
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedQuestions, setGeneratedQuestions] = useState([]);
  const [showQuestionEditor, setShowQuestionEditor] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState('');
  const [redoingIndex, setRedoingIndex] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);

  const today = new Date().toISOString().split('T')[0];

  const getSubjectIdForRAG = () => {
    if (!selectedRecipient) return null;
    if (selectedRecipient.subjectId) {
      return selectedRecipient.subjectId;
    }
    return null;
  };

  const studentCount = countStudentsForRecipient(selectedRecipient);

  const handleGenerateQuestions = async () => {
    if (!topic.trim()) {
      setError('Por favor, escribe un tema para el reto');
      return;
    }
    
    if (!deadline) {
      setError('Por favor, selecciona una fecha límite');
      return;
    }
    
    if (!selectedRecipient) {
      setError('Por favor, selecciona un destinatario');
      return;
    }

    const subjectId = getSubjectIdForRAG();
    if (!subjectId) {
      setError('Por favor, selecciona una asignatura específica para generar preguntas desde RAG');
      return;
    }

    setError('');
    setIsGenerating(true);
    setShowQuestionEditor(true);
    setGeneratedQuestions([]);

    try {
      const response = await fetch(`${API_BASE}/api/challenges/generate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          topic: topic.trim(),
          subject_id: subjectId,
          num_questions: 10
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Error al generar preguntas');
      }

      const data = await response.json();
      const questionsWithType = (data.questions || []).map(q => ({
        ...q,
        type: 'multiple_choice'
      }));
      setGeneratedQuestions(questionsWithType);
    } catch (err) {
      console.error('Error generating questions:', err);
      setError(err.message || 'Error al generar las preguntas');
      setGeneratedQuestions([]);
    } finally {
      setIsGenerating(false);
    }
  };

  // Question actions
  const handleDelete = (index) => {
    setGeneratedQuestions(prev => prev.filter((_, i) => i !== index));
  };

  const handleRedo = async (index) => {
    setRedoingIndex(index);
    try {
      const existingQuestionTexts = generatedQuestions.map(q => q.question);
      
      const response = await fetch(`${API_BASE}/api/challenges/regenerate-question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          topic: topic,
          subject_id: getSubjectIdForRAG(),
          existing_questions: existingQuestionTexts
        })
      });

      if (!response.ok) {
        throw new Error('Error al regenerar pregunta');
      }

      const newQuestion = await response.json();
      setGeneratedQuestions(prev => {
        const newQuestions = [...prev];
        newQuestions[index] = { ...newQuestion, type: 'multiple_choice' };
        return newQuestions;
      });
    } catch (err) {
      console.error('Error regenerating question:', err);
    } finally {
      setRedoingIndex(null);
    }
  };

  const handleConvertToOpen = (index) => {
    setGeneratedQuestions(prev => {
      const newQuestions = [...prev];
      newQuestions[index] = {
        question: newQuestions[index].question,
        type: 'open',
        source: newQuestions[index].source
      };
      return newQuestions;
    });
  };

  const handleEdit = (index, updatedQuestion) => {
    setGeneratedQuestions(prev => {
      const newQuestions = [...prev];
      newQuestions[index] = updatedQuestion;
      return newQuestions;
    });
  };

  const handleAddNew = async () => {
    setIsAddingNew(true);
    try {
      const existingQuestionTexts = generatedQuestions.map(q => q.question);
      
      const response = await fetch(`${API_BASE}/api/challenges/regenerate-question`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          topic: topic,
          subject_id: getSubjectIdForRAG(),
          existing_questions: existingQuestionTexts
        })
      });

      if (!response.ok) {
        throw new Error('Error al añadir pregunta');
      }

      const newQuestion = await response.json();
      setGeneratedQuestions(prev => [...prev, { ...newQuestion, type: 'multiple_choice' }]);
    } catch (err) {
      console.error('Error adding question:', err);
    } finally {
      setIsAddingNew(false);
    }
  };

  const handleSendChallenge = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/challenges`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          topic: topic.trim(),
          deadline: deadline,
          recipient: selectedRecipient,
          questions: generatedQuestions,
          subject_id: getSubjectIdForRAG()
        })
      });

      if (!response.ok) {
        throw new Error('Error al enviar el reto');
      }

      setShowQuestionEditor(false);
      setShowSuccess(true);
    } catch (err) {
      console.error('Error sending challenge:', err);
      setError(err.message);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    setTopic('');
    setDeadline('');
    setSelectedRecipient(null);
    setGeneratedQuestions([]);
  };

  const handleBackToConfig = () => {
    setShowQuestionEditor(false);
    setGeneratedQuestions([]);
  };

  // ============================================
  // RENDER: QUESTION EDITOR VIEW
  // ============================================
  if (showQuestionEditor) {
    return (
      <div className="flex flex-col h-full p-4 overflow-hidden" data-testid="crear-retos-view">
        {/* Header with back button */}
        <div className="flex-shrink-0 mb-4">
          <button
            onClick={handleBackToConfig}
            className="flex items-center gap-2 text-gray-400 hover:text-white text-sm mb-3 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver a configuración
          </button>
          <div className="flex items-center gap-2 mb-1">
            <FileText className="w-5 h-5 text-amber-400" />
            <h1 className="text-lg font-semibold text-white">Revisar y editar preguntas</h1>
          </div>
          <p className="text-xs text-gray-500">
            {topic} • {selectedRecipient?.label}
          </p>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
          {isGenerating ? (
            <div className="flex flex-col items-center justify-center py-16">
              <Loader2 className="w-10 h-10 text-amber-400 animate-spin mb-4" />
              <p className="text-sm text-gray-400">Generando preguntas desde el conocimiento RAG...</p>
              <p className="text-xs text-gray-500 mt-2">Esto puede tardar unos segundos</p>
            </div>
          ) : generatedQuestions.length > 0 ? (
            <div className="space-y-4">
              {generatedQuestions.map((q, idx) => (
                <QuestionCard
                  key={idx}
                  question={q}
                  index={idx}
                  onDelete={handleDelete}
                  onRedo={handleRedo}
                  onConvertToOpen={handleConvertToOpen}
                  onEdit={handleEdit}
                  isRedoing={redoingIndex === idx}
                />
              ))}

              {/* Add New Question Button */}
              <button
                onClick={handleAddNew}
                disabled={isAddingNew}
                className="w-full flex items-center justify-center gap-2 p-4 border-2 border-dashed border-gray-700 hover:border-amber-500/50 rounded-lg text-gray-400 hover:text-amber-400 transition-colors disabled:opacity-50"
              >
                {isAddingNew ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span className="text-sm">Generando nueva pregunta...</span>
                  </>
                ) : (
                  <>
                    <Plus className="w-4 h-4" />
                    <span className="text-sm font-medium">Añadir nueva pregunta</span>
                  </>
                )}
              </button>

              {/* Summary and Send Section */}
              <div className="mt-6 p-4 bg-gray-800/50 rounded-xl border border-gray-700/50">
                <div className="flex items-start gap-3 mb-4">
                  <div className="p-2 bg-amber-500/20 rounded-lg">
                    <Users className="w-5 h-5 text-amber-400" />
                  </div>
                  <div>
                    <p className="text-sm text-white font-medium">
                      Este reto se enviará a un total de <span className="text-amber-400">{studentCount} alumno{studentCount !== 1 ? 's' : ''}</span>
                    </p>
                    <p className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      Para contestarse antes de las 23:59 del {formatDateSpanish(deadline)}
                    </p>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-gray-700/50">
                  <p className="text-xs text-gray-500">
                    {generatedQuestions.length} pregunta{generatedQuestions.length !== 1 ? 's' : ''} • 
                    {generatedQuestions.filter(q => q.type === 'open').length} abierta{generatedQuestions.filter(q => q.type === 'open').length !== 1 ? 's' : ''} • 
                    {generatedQuestions.filter(q => q.type !== 'open').length} opción múltiple
                  </p>
                  <button
                    onClick={handleSendChallenge}
                    className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white text-sm font-semibold rounded-lg transition-all shadow-lg shadow-amber-500/20"
                  >
                    <Send className="w-4 h-4" />
                    Crear y enviar reto
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-12">
              <AlertCircle className="w-12 h-12 text-amber-400 mx-auto mb-3" />
              <p className="text-sm text-gray-400">No se pudieron generar preguntas</p>
              <p className="text-xs text-gray-500 mt-1">Verifica que el tema esté cubierto en los documentos de conocimiento</p>
            </div>
          )}
        </div>

        {/* Success Modal */}
        <SuccessModal
          isOpen={showSuccess}
          onClose={handleSuccessClose}
          recipientLabel={selectedRecipient?.label || ''}
          studentCount={studentCount}
        />
      </div>
    );
  }

  // ============================================
  // RENDER: CONFIGURATION VIEW
  // ============================================
  return (
    <div className="flex flex-col h-full p-4 overflow-hidden" data-testid="crear-retos-view">
      {/* Header */}
      <div className="flex-shrink-0 mb-4">
        <div className="flex items-center gap-2 mb-1">
          <Trophy className="w-5 h-5 text-amber-400" />
          <h1 className="text-lg font-semibold text-white">Crear Reto</h1>
        </div>
        <p className="text-xs text-gray-500">
          Genera un test basado en el conocimiento de tus asignaturas
        </p>
      </div>

      {/* Error Message */}
      {error && (
        <div className="flex-shrink-0 flex items-center gap-2 mb-3 px-3 py-1.5 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-xs">
          <AlertCircle className="w-3.5 h-3.5" />
          <span>{error}</span>
        </div>
      )}

      {/* Scrollable Content Area */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden min-h-0">
        {/* Configuration Card */}
        <div className="mb-4 bg-gray-800/50 rounded-xl border border-gray-700/50 overflow-hidden">
          <div className="px-4 py-3 bg-gradient-to-r from-amber-600/20 to-orange-600/20 border-b border-gray-700/50">
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-amber-400" />
              <h2 className="text-sm font-semibold text-white">Configuración del reto</h2>
            </div>
          </div>
          <div className="p-4 space-y-4">
            {/* Topic Field */}
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-gray-400">
                Genera un test sobre:
              </label>
              <input
                type="text"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                placeholder="Escribe un tema incluido en mis conocimientos"
                className="w-full px-3 py-2 bg-gray-900/50 border border-gray-700 rounded-lg text-sm text-white placeholder-gray-500 focus:outline-none focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/50 transition-all"
                data-testid="topic-input"
              />
            </div>

            {/* Deadline Field */}
            <div className="space-y-1.5">
              <label className="text-xs font-medium text-gray-400">
                Con fecha límite del:
              </label>
              <div className="relative">
                <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none" />
                <input
                  type="date"
                  value={deadline}
                  onChange={(e) => setDeadline(e.target.value)}
                  min={today}
                  className="w-full pl-10 pr-3 py-2 bg-gray-900/50 border border-gray-700 rounded-lg text-sm text-white focus:outline-none focus:border-amber-500/50 focus:ring-1 focus:ring-amber-500/50 transition-all appearance-none cursor-pointer
                    [&::-webkit-calendar-picker-indicator]:opacity-0 
                    [&::-webkit-calendar-picker-indicator]:absolute 
                    [&::-webkit-calendar-picker-indicator]:inset-0 
                    [&::-webkit-calendar-picker-indicator]:w-full 
                    [&::-webkit-calendar-picker-indicator]:h-full 
                    [&::-webkit-calendar-picker-indicator]:cursor-pointer"
                  data-testid="deadline-input"
                />
              </div>
              {deadline && (
                <p className="text-xs text-gray-500">
                  Fecha límite: {formatDateSpanish(deadline)} a las 23:59
                </p>
              )}
            </div>
          </div>
        </div>

        {/* Recipient Tree Selector */}
        <div className="mb-4">
          <RecipientTreeSelector 
            selectedRecipient={selectedRecipient}
            onSelect={setSelectedRecipient}
            onBlockedSelection={() => setShowDemoModal(true)}
          />
        </div>

        {/* Warning if no subject selected */}
        {selectedRecipient && !selectedRecipient.subjectId && (
          <div className="mb-4 flex items-center gap-2 p-2.5 bg-amber-500/10 border border-amber-500/30 rounded-lg text-amber-400 text-xs">
            <AlertCircle className="w-3.5 h-3.5 flex-shrink-0" />
            <span>Selecciona una asignatura específica para generar preguntas desde RAG</span>
          </div>
        )}

        {/* Student count preview */}
        {selectedRecipient && selectedRecipient.subjectId && (
          <div className="mb-4 flex items-center gap-2 p-2.5 bg-gray-800/50 border border-gray-700/50 rounded-lg text-gray-300 text-xs">
            <Users className="w-3.5 h-3.5 flex-shrink-0 text-amber-400" />
            <span>
              Este reto se enviará a <span className="text-amber-400 font-medium">{studentCount} alumno{studentCount !== 1 ? 's' : ''}</span>
            </span>
          </div>
        )}

        {/* Generate Button */}
        <button
          onClick={handleGenerateQuestions}
          disabled={!topic.trim() || !deadline || !selectedRecipient || isGenerating}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 disabled:from-gray-600 disabled:to-gray-600 disabled:cursor-not-allowed text-white text-sm font-semibold rounded-xl transition-all shadow-lg shadow-amber-500/20 disabled:shadow-none"
          data-testid="generate-btn"
        >
          {isGenerating ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" />
              Generando reto...
            </>
          ) : (
            <>
              <Sparkles className="w-4 h-4" />
              Generar reto
            </>
          )}
        </button>
      </div>

      {/* Success Modal */}
      <SuccessModal
        isOpen={showSuccess}
        onClose={handleSuccessClose}
        recipientLabel={selectedRecipient?.label || ''}
        studentCount={studentCount}
      />

      {/* Demo Restriction Modal */}
      <DemoRestrictionModal
        isOpen={showDemoModal}
        onClose={() => setShowDemoModal(false)}
      />
    </div>
  );
};

export default CrearRetosView;
